<template>
    <div class="breadcrumb mb-12">
        <span v-for="(path, index) in paths" :key="index" class="text-blue">
            <span v-if="path.isText">{{ path.text }} </span>

            <span v-else>
                <router-link
                             class="cursor-pointer"
                             :to="{ name: path.name, params: path.params }"
                                >
                    {{ path.text }}
                </router-link>
                 /
            </span>
        </span>
    </div>
</template>

<script charset="utf-8">

import Vuex from 'vuex';

export default {

    data() {
        return {

        }
    },
    computed: {
        ...Vuex.mapGetters('layout', {
            paths: 'paths'
        }),
    },
}
</script>
